import { localized } from '@/i18n/localize'
export const notificationStrings = localized({
  title: 'Notifications',
  unreadCount: (n: number) => `${n} unread`,
  markAllRead: 'Mark all read',
  filterAll: 'All',
  filterUnread: 'Unread',
  empty: 'Nothing here yet',
  emptyDesc: 'Rent, lease, agreement and maintenance updates will show up here.',
  emptyUnread: "You're all caught up",
  today: 'Today',
  earlier: 'Earlier',
  loadMore: 'Load more',
  unreadDot: 'Unread',
  justNow: 'Just now',
  minutesAgo: (n: number) => `${n}m ago`,
  hoursAgo: (n: number) => `${n}h ago`,
  yesterday: 'Yesterday',
  daysAgo: (n: number) => `${n}d ago`,
  somethingWentWrong: 'Something went wrong',
  readFilter: 'Show',
  typeFilter: 'Type',
  allTypes: 'All types',
  bucket: { rent: 'Rent & payments', lease: 'Leases', agreement: 'Agreements', interest: 'Interests', maintenance: 'Maintenance', other: 'Other' },
  selectAll: 'Select all',
  selectRow: (title: string) => `Select "${title}"`,
  selected: (n: number) => `${n} selected`,
  markSelectedRead: 'Mark as read',
  clearSelection: 'Clear',
  markRead: 'Mark as read',
  open: 'Open',
  showing: (shown: number, total: number) => `Showing ${shown} of ${total}`,
  typeLoadedHint: 'Types filter the notifications loaded so far. Load more to look further back.',
  emptyType: 'No notifications of this type yet',
  emptyTypeLoaded: 'None of this type in the loaded notifications.',
})
